/* import __COLOCATED_TEMPLATE__ from './tts-language-select.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { TTS_LANGUAGE_OPTIONS } from 'embercom/objects/calling/tts-language-options';

interface Args {
  /** Current selected language code (e.g., 'en-US') */
  selectedValue: string;
  /** Callback when selection changes */
  onSelectItem: (value: string) => void;
  /** Optional disabled state */
  isDisabled?: boolean;
  /** Optional CSS class */
  class?: string;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}

/**
 * Unified TTS language dropdown component for phone/calling features.
 *
 * Usage:
 * ```handlebars
 * <Calling::TtsLanguageSelect
 *   @selectedValue={{this.ttsLanguage}}
 *   @onSelectItem={{this.updateTtsLanguage}}
 *   @isDisabled={{@readOnly}}
 * />
 * ```
 */
export default class TtsLanguageSelect extends Component<Signature> {
  @service declare intl: IntlService;

  get languageOptions() {
    return TTS_LANGUAGE_OPTIONS.map((option) => ({
      text: this.intl.t(option.text),
      value: option.value,
    }));
  }

  get filterPlaceholder() {
    return this.intl.t('calling.settings.tts-language-select.filter-placeholder');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Calling::TtsLanguageSelect': typeof TtsLanguageSelect;
    'calling/tts-language-select': typeof TtsLanguageSelect;
  }
}
